/** Production, or a deploy that opts into production guards. Live payment keys are honoured only here. */
export function isDeployable(env: { NODE_ENV?: string; DEPLOYABLE?: string }): boolean {
  return env.NODE_ENV === "production" || env.DEPLOYABLE === "true";
}
